<script lang="ts">
	import { page } from '$app/stores';
</script>

{#if $page.url.pathname !== '/events'}
	<nav class="mb-6 flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
		<a href="/events" class="no-underline hover:text-blue-600 dark:hover:text-blue-400">← Events</a>
	</nav>
{/if}

<div class="prose prose-lg dark:prose-invert max-w-none">
	<slot />
</div>
